// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'quill';

export const Component = () => (
  <path d='M0 24.52h1.533l4.597-7.662h4.598c1.054 0 2.156-.67 3.257-1.963 1.102-1.293 2.06-2.826 2.97-4.55.91-1.677 2.06-3.544 3.448-5.604 1.39-2.059 2.73-3.64 4.119-4.741-2.538 0-5.029.575-7.376 1.677-2.394 1.149-4.454 2.585-6.178 4.262-1.724 1.724-3.352 3.736-4.838 5.987-1.532 2.299-2.778 4.454-3.687 6.465-.958 2.06-1.772 4.072-2.442 6.13H0Z' />
);

export const viewBox = '0 0 25 25';
